import { PropsWithChildren, useMemo } from 'react'
import { useAuth } from '../utils/hooks'
import { CmsWebsiteBM, CustomerBM, WebsiteFM } from '@bm-js/atlascloud-shared'
import { useApi } from '../utils/useApi'
import { AppContext } from '../contexts/AppState.context'

export const AppContextProvider = ({ children }: PropsWithChildren) => {
  const { isAuthenticating, token, user } = useAuth()

  const enabled = useMemo(
    () => !isAuthenticating && !!token && !!user,
    [isAuthenticating, token, user]
  )

  const { data: atlasWebsite, refetch: _refetchAtlasWebsite } =
    useApi<WebsiteFM>('customer/website', {
      enabled,
      queryKeys: [token, user?._id],
    })

  const { data: cmsWebsite, refetch: _refetchCmsWebsite } =
    useApi<CmsWebsiteBM>('cms-user/website', {
      enabled,
      queryKeys: [token, user?._id],
    })

  const { data: customer } = useApi<CustomerBM>('customer/customer', {
    enabled,
    queryKeys: [token, user?._id],
  })

  const refetchAtlasWebsite = async () => {
    await _refetchAtlasWebsite()
  }

  const refetchCmsWebsite = async () => {
    await _refetchCmsWebsite()
  }

  return (
    <AppContext.Provider
      value={{
        refetchAtlasWebsite,
        refetchCmsWebsite,
        atlasWebsite: atlasWebsite || null,
        cmsWebsite: cmsWebsite || null,
        customer: customer || null,
        anyWebsite: atlasWebsite || cmsWebsite || null,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
